module.exports = ".example-container{height:600px;overflow:auto}mat-table{width:100%}.caducado{color:red}.onTime{color:green}\n"